import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-app-section',
  templateUrl: './app-section.component.html',
  styleUrls: ['./app-section.component.css']
})
export class AppSectionComponent implements OnInit {

  @Input() sectionInfo;
  @Output() public callToAction = new EventEmitter();

  cta;
  
  constructor() { 
    if(this.sectionInfo){
      this.sectionInfo.array? null :  this.sectionInfo.array = [];
    }
  }

  ngOnInit(): void {
  }

  getItemClass(cardData,item){
    switch(cardData.iconSize){
      case 'sm':
        return 'icon-sm';
      case 'md':
        return item.icon + ' icon-md'
      case 'lg':
        return item.icon + ' icon-lg'
      default:
        return item.icon + ' icon-sm'
    }
  }

  getItemCntClass(cardData){
    return 'item-media event-icon ' + cardData.iconSize+'-cnt'
  }

  

}
